/* eslint-disable import/prefer-default-export */
export const MXP_ACCOUNT_FUND = 'MXP_ACCOUNT_FUND';
export const MXP_ACCOUNT_ADD = 'MXP_ACCOUNT_ADD';
